import React from 'react';
import { Loading } from '../../Message';
import { MediaMessage } from '../../../../../chat-api';
import {
  ImageContainer,
  MediaRow,
  ImageItem,
  MediaWithoutCaption,
  MediaTag
} from './styles';

interface MessageBodyImageProps {
  message: MediaMessage,
  mediaImage: HTMLImageElement | null;
  imageBlob: Blob | null;
}

function MessageBodyImage({ message, mediaImage, imageBlob }: MessageBodyImageProps) {
  const handleClick = () => {
    if (message.body.file && imageBlob) {
      window.open(URL.createObjectURL(imageBlob), '_blank');
    }
  }

  return (
    <ImageContainer as="sdiv">
      <MediaRow as="sdiv" style={{
        width: '250px', height: `${mediaImage ? `${(250 / mediaImage?.width) * mediaImage.height}px` : '250px'}`
      }}>
        <ImageItem as="sdiv">
          {(!mediaImage || !mediaImage.src) ?
            <Loading message={message}/>
          :
            <ImageItem as="sdiv" onClick={handleClick}>
              <MediaTag src={mediaImage?.src} alt="image_description" />
            </ImageItem>
          }
          <MediaWithoutCaption />
        </ImageItem>
      </MediaRow>
    </ImageContainer>
  );
}

export default React.memo(MessageBodyImage);